import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { environment } from 'environments/environment';

/**
 * The footer half of the page skeleton (header / body / footer), sibling to
 * `HeaderComponent`.
 *
 * Was duplicated verbatim in every page template, which is how the cookie link
 * would have had to be added sixteen times — and how one page would eventually
 * have been missed. The markup, the spacing and the app version now live here
 * once.
 */
@Component({
    selector: 'app-page-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FooterComponent {
    public readonly appVersion: string = environment.appVersion;

    /** Whether the cookie preferences dialog is open. */
    public preferencesVisible = false;

    /**
     * Page containers style the footer slot with `.footer { flex-shrink: 0 }`,
     * so the class has to sit on the host for those rules to keep matching.
     */
    @HostBinding('class.footer')
    readonly isFooter = true;

    /** Opens the dialog showing the current cookie choice. */
    openCookiePreferences(): void {
        this.preferencesVisible = true;
    }
}
